/** @format */

import getConfig from "next/config";
import Image from "next/image";

const { publicRuntimeConfig } = getConfig();
const { NEXT_PUBLIC_CDN_URL } = publicRuntimeConfig;

export default function Panel2() {
  return (
    <div className="container w-full text-black bg-white my-14 md:my-28">
      <fieldset className="w-full px-8 py-12 ">
        <legend className="px-4 mx-auto text-center text-brown md:text-2xl text-semibold">
          JOIN OTHER ROADFLEX PARTNERS
        </legend>
        <div className="flex flex-col flex-wrap items-center justify-center w-full gap-8 md:gap-4 md:flex-row xs:justify-between">
          <a
            href="https://fleetup.com/lp/roadflex-promotion/"
            className="relative w-20 md:w-28 min-h-[10px] max-h-[36px] md:h-full self-center"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Image
              layout="fixed"
              width={"130"}
              height={"30"}
              className=""
              src={`${NEXT_PUBLIC_CDN_URL}/common/partner-logos/logo-fleetup.png`}
              alt="fleetup"
            ></Image>
          </a>
          <Image
            layout="fixed"
            width={"144"}
            height={"90"}
            className=""
            src={`${NEXT_PUBLIC_CDN_URL}/common/partner-logos/logo-geotab.png`}
            alt="geotab"
          ></Image>
          <Image
            layout="fixed"
            width={"131"}
            height={"70"}
            className=""
            src={`${NEXT_PUBLIC_CDN_URL}/common/partner-logos/logo-fleetio.png`}
            alt="fleetio"
          ></Image>
          <Image
            layout="fixed"
            width={"120"}
            height={"40"}
            className=""
            src={`${NEXT_PUBLIC_CDN_URL}/common/partner-logos/logo-verizon-connect.png`}
            alt="verizon connect"
          ></Image>
          <Image
            layout="fixed"
            width={"124"}
            height={"42"}
            className=""
            src={`${NEXT_PUBLIC_CDN_URL}/common/partner-logos/logo-azuga.png`}
            alt="azuga"
          ></Image>
          <Image
            layout="fixed"
            width={"220"}
            height={"80"}
            className=""
            src={`${NEXT_PUBLIC_CDN_URL}/common/partner-logos/logo-samsara.png`}
            alt="samsara"
          ></Image>
        </div>
      </fieldset>
    </div>
  );
}
